import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  constructor(private http: HttpClient) {}

  createFeature(featureName: any): Observable<any> {
    return this.http.post(
      `${environment.authUrl}/subscription/feature`,
      featureName
    );
  }

  getAllFeatures(): Observable<any> {
    return this.http.get(`${environment.authUrl}/subscription/features`);
  }

  createPlan(planName: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/subscription/plan`, planName);
  }

  getAllPlans(): Observable<any> {
    return this.http.get(`${environment.authUrl}/subscription/plans`);
  }

  getAllPlansFeaturesMapping(): Observable<any> {
    return this.http.get(`${environment.authUrl}/subscription/plan-features`);
  }

  updatePlansFeaturesMapping(data: any[]): Observable<any> {
    return this.http.patch(`${environment.authUrl}/subscription/plan-feature`, {
      data,
    });
  }

  updateFeaturePosition(data: any[]): Observable<any> {
    return this.http.put(
      `${environment.authUrl}/subscription/feature/change-position`,
      {
        data,
      }
    );
  }

  updateFeature(id: number, data: {}): Observable<any> {
    return this.http.patch(
      `${environment.authUrl}/subscription/feature/${id}`,
      data
    );
  }

  deleteFeature(id: number): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/subscription/feature/${id}`
    );
  }
}
